<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row" v-if="userData.permissions['class_mgt'] == 1">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <div class="mb-2 float-end">
                <b-button v-b-modal.new-item size="sm" variant="primary"
                  ><i class="mdi mdi-plus"></i> New Grading System</b-button
                >
              </div>
              <div class="clearfix"></div>
              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                      Show
                      <b-form-select
                        class="form-select form-select-sm mx-1"
                        v-model="perPage"
                        size="sm"
                        :options="Options"
                      ></b-form-select>
                      entries
                    </label>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6">
                  <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                  >
                    <label class="d-inline-flex align-items-center">
                      Search:
                      <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ms-2"
                      ></b-form-input>
                    </label>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <b-table
                  :items="Items"
                  :fields="Fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="Filtered"
                  :busy="IsBusy"
                >
                  <template #table-busy
                    ><div class="text-center text-primary my-2">
                      <b-spinner
                        class="align-middle"
                        type="grow"
                        small
                      ></b-spinner>
                      <strong>No Data Found</strong>
                    </div></template
                  >
                  <template #cell(index)="data">
                    {{ data.index + 1 }}
                  </template>
                  <template #cell(class)="data">
                    {{ data.item.class.name }}
                  </template>
                  <template #cell(actions)="data">
                    <div class="btn-group">
                      <b-button
                        @click="remove(data.item.id, data.item.class.name)"
                        type="button"
                        class="btn-sm btn"
                        variant="danger"
                        v-b-modal.delete
                      >
                        <i class="mdi mdi-trash-can"></i>
                      </b-button>
                    </div>
                  </template>
                </b-table>
              </div>
              <div class="row">
                <div class="col">
                  <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                  >
                    <ul class="pagination pagination-rounded mb-0">
                      <b-pagination
                        v-model="currentPage"
                        :total-rows="List"
                        :per-page="perPage"
                      ></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <b-modal
        id="new-item"
        centered
        title="New Grading System"
        title-class="font-18"
        hide-footer
      >
        <form @submit.prevent="addItem">
          <div class="form-group mb-2">
            <label>Class</label>
            <multiselect
              v-model="schoolclass"
              label="name"
              :options="
                schoolclasses.filter((schoolclass) => schoolclass.level === 1)
              "
            ></multiselect>
            <div class="row mt-2">
              <div class="col-1">F9</div>
              <div class="col-5">
                <input
                  v-model="f9a"
                  type="text"
                  readonly
                  class="form-control"
                />
              </div>
              <div class="col-6">
                <input
                  v-model="f9b"
                  @input="f9bChange"
                  type="text"
                  class="form-control"
                />
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-1">P8</div>
              <div class="col-5">
                <input
                  v-model="p8a"
                  type="text"
                  readonly
                  class="form-control"
                />
              </div>
              <div class="col-6">
                <input
                  v-model="p8b"
                  @input="p8bChange"
                  type="text"
                  class="form-control"
                />
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-1">P7</div>
              <div class="col-5">
                <input
                  v-model="p7a"
                  type="text"
                  readonly
                  class="form-control"
                />
              </div>
              <div class="col-6">
                <input
                  v-model="p7b"
                  @input="p7bChange"
                  type="text"
                  class="form-control"
                />
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-1">C6</div>
              <div class="col-5">
                <input
                  v-model="c6a"
                  type="text"
                  readonly
                  class="form-control"
                />
              </div>
              <div class="col-6">
                <input
                  v-model="c6b"
                  @input="c6bChange"
                  type="text"
                  class="form-control"
                />
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-1">C5</div>
              <div class="col-5">
                <input
                  v-model="c5a"
                  type="text"
                  readonly
                  class="form-control"
                />
              </div>
              <div class="col-6">
                <input
                  v-model="c5b"
                  @input="c5bChange"
                  type="text"
                  class="form-control"
                />
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-1">C4</div>
              <div class="col-5">
                <input
                  v-model="c4a"
                  type="text"
                  readonly
                  class="form-control"
                />
              </div>
              <div class="col-6">
                <input
                  v-model="c4b"
                  @input="c4bChange"
                  type="text"
                  class="form-control"
                />
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-1">C3</div>
              <div class="col-5">
                <input
                  v-model="c3a"
                  type="text"
                  readonly
                  class="form-control"
                />
              </div>
              <div class="col-6">
                <input
                  v-model="c3b"
                  @input="c3bChange"
                  type="text"
                  class="form-control"
                />
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-1">D2</div>
              <div class="col-5">
                <input
                  v-model="d2a"
                  type="text"
                  readonly
                  class="form-control"
                />
              </div>
              <div class="col-6">
                <input
                  v-model="d2b"
                  @input="d2bChange"
                  type="text"
                  class="form-control"
                />
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-1">D1</div>
              <div class="col-5">
                <input
                  v-model="d1a"
                  type="text"
                  readonly
                  class="form-control"
                />
              </div>
              <div class="col-6">
                <input
                  v-model="d1b"
                  readonly
                  type="text"
                  class="form-control"
                />
              </div>
            </div>
          </div>
          <div class="form-group d-flex justify-content-end">
            <b-button
              type="button"
              class="btn w-30"
              variant="secondary"
              @click="$bvModal.hide('new-item')"
              >Close</b-button
            >
            <b-button type="submit" class="btn ms-1 w-30" variant="primary"
              ><i class="fas fa-check-circle"></i> Submit</b-button
            >
          </div>
        </form>
      </b-modal>

      <b-modal
        id="delete-item"
        centered
        title="Delete Grading System"
        title-class="font-18"
        hide-footer
      >
        <form @submit.prevent="removeItem">
          <input v-model="id" type="hidden" />
          Are you sure you want to delete the Subject : <b>{{ name }}</b> ?
          <div class="form-group d-flex justify-content-end">
            <b-button
              type="button"
              class="btn w-30"
              variant="secondary"
              @click="$bvModal.hide('delete-item')"
              >Close</b-button
            >
            <b-button type="submit" class="btn ms-1 w-30" variant="primary"
              ><i class="fas fa-check-circle"></i> YES</b-button
            >
          </div>
        </form>
      </b-modal>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <center>
              <span class="text-primary h4"
                >You have no permission to view this Page.</span
              >
            </center>
            <img
              src="@/assets/images/profile-img.png"
              alt
              class="img-fluid"
            /><br /><br />
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import {
  gradingComputed,
  gradingMethods,
  schoolclassComputed,
  schoolclassMethods,
} from "@/state/helpers";
import axios from "axios";
import Multiselect from "vue-multiselect";
import Layout from "../../layouts/main";

export default {
  page: {
    title: "Grading System",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Multiselect,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "Grading System",
      items: [
        { text: "Dashboard", to: "/" },
        { text: "Grading System", active: true },
      ],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      fields: [
        { key: "index", label: "#", visible: true },
        { key: "id", label: "ID", visible: false },
        { key: "class", label: "Class", visible: true },
        { key: "f9", label: "F9", visible: true },
        { key: "p8", label: "P8", visible: true },
        { key: "p7", label: "P7", visible: true },
        { key: "c6", label: "C6", visible: true },
        { key: "c5", label: "C5", visible: true },
        { key: "c4", label: "C4", visible: true },
        { key: "c3", label: "C3", visible: true },
        { key: "d2", label: "D2", visible: true },
        { key: "d1", label: "D1", visible: true },
        { key: "actions", label: "Actions", visible: true },
      ],
      id: "",
      name: "",
      f9a: 0,
      f9b: "",
      p8a: "",
      p8b: "",
      p7a: "",
      p7b: "",
      c6a: "",
      c6b: "",
      c5a: "",
      c5b: "",
      c4a: "",
      c4b: "",
      c3a: "",
      c3b: "",
      d2a: "",
      d2b: "",
      d1a: "",
      d1b: "100",
      schoolclass: "",
    };
  },
  computed: {
    ...gradingComputed,
    ...schoolclassComputed,
    List() {
      return this.gradings.length;
    },
    Fields() {
      return this.fields.filter((field) => field.visible);
    },
    Items() {
      return this.gradings.map((d) => ({ ...d }));
    },
    IsBusy() {
      let a = false;
      if (this.gradings.length > 0) {
        a = false;
      } else {
        a = true;
      }
      return a;
    },
  },
  mounted() {
    this.fetchGrading();
    this.fetchSchoolClasses();
    this.TotalRows = this.gradings.length;
    this.isBusy = false;
  },
  methods: {
    ...gradingMethods,
    ...schoolclassMethods,
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    remove(id, name) {
      this.id = id;
      this.name = name;
      this.$bvModal.show("delete-item");
    },
    async addItem() {
      let formData = new FormData();
      formData.append("class", this.schoolclass.id);
      formData.append("f9", this.f9a + " - " + this.f9b);
      formData.append("p8", this.p8a + " - " + this.p8b);
      formData.append("p7", this.p7a + " - " + this.p7b);
      formData.append("c6", this.c6a + " - " + this.c6b);
      formData.append("c5", this.c5a + " - " + this.c5b);
      formData.append("c4", this.c4a + " - " + this.c4b);
      formData.append("c3", this.c3a + " - " + this.c3b);
      formData.append("d2", this.d2a + " - " + this.d2b);
      formData.append("d1", this.d1a + " - " + this.d1b);
      let url = "/addgradingsystem";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchGrading();
          this.$bvModal.hide("new-item");
          this.class = "";
          this.$swal({
            title: "Success",
            text: response.data.message,
            icon: "success",
          });
        }
      });
    },
    async removeItem() {
      let formData = new FormData();
      formData.append("id", this.id);
      let url = "/removegradingsystem";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchGrading();
          this.$bvModal.hide("delete-item");
          this.$swal({
            title: "Success",
            text: response.data.message,
            icon: "success",
          });
        }
      });
    },
    f9bChange() {
      this.p8a = Number(this.f9b) + 1;
    },
    p8bChange() {
      this.p7a = Number(this.p8b) + 1;
    },
    p7bChange() {
      this.c6a = Number(this.p7b) + 1;
    },
    c6bChange() {
      this.c5a = Number(this.c6b) + 1;
    },
    c5bChange() {
      this.c4a = Number(this.c5b) + 1;
    },
    c4bChange() {
      this.c3a = Number(this.c4b) + 1;
    },
    c3bChange() {
      this.d2a = Number(this.c3b) + 1;
    },
    d2bChange() {
      this.d1a = Number(this.d2b) + 1;
    },
  },
};
</script>
